import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";

import { fetchWrapper } from "_helpers";
import { Slide, toast } from "react-toastify";

const name = "filter";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers: {
    resetFilterOptions: (state, action) => {
      state.filterOptions = {};
    },
  },
  extraReducers,
});

function createInitialState() {
  return {
    loading: false,
    filterOptions: {},
  };
}

export const filterActions = {...slice.actions, ...extraActions };
export const filterReducer = slice.reducer;

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;

  return {
    getFilterOptions: getFilterOptions(),
  };
  function getFilterOptions() {
    return createAsyncThunk(
      `${name}/getFilterOptions`,
      async () => await fetchWrapper.get(`${baseUrl}/common/filters`)
    );
  }
}

function createExtraReducers() {
  return (builder) => {
    getFilterOptions();
    function getFilterOptions() {
      var { pending, fulfilled, rejected } = extraActions.getFilterOptions;
      builder
        .addCase(pending, (state) => {
          state.loading = true;
        })
        .addCase(fulfilled, (state, action) => {
          state.filterOptions = action?.payload?.data;
          state.loading = false;
        })
        .addCase(rejected, (state, action) => {
          toast.error(
            <div>
              ❗ Something went wrong!
              <br /> Please try again later.
            </div>,
            {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: Slide,
            }
          );
          state.filterOptions = {};
          state.loading = false;
        });
    }
  };
}
